import colors from "./helpers/colors";

/** @type {ColorMap} */
export default {
  // strike zone
  strikeZone: colors.black.default,
  strikeZoneSectors: colors.black.default,
  foulLine: colors.grey.alto,
  grassLine: colors.grey.alto,

  hiddenSeries: 'transparent',
  default: colors.blue.default,
};

